var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminSettingsPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61022 1.00018C6.51374 1.00339 6.42218 1.04648 6.35501 1.12035L1.10855 6.71623C1.03909 6.79046 1 6.8911 1 6.99603C1 7.10095 1.03909 7.20159 1.10855 7.27582L6.35501 12.8717C6.42349 12.9513 6.51947 12.9976 6.62064 12.9999C6.72188 13.0022 6.81968 12.9604 6.89128 12.884C6.96288 12.8076 7.00213 12.7033 6.99991 12.5954C6.99769 12.4874 6.95434 12.3851 6.8797 12.3121L1.89558 6.99603L6.8797 1.67994C6.95163 1.60536 6.99211 1.50293 6.99211 1.39595C6.99211 1.28896 6.95146 1.18655 6.87954 1.11195C6.80761 1.03745 6.71047 0.997126 6.61022 1.00016L6.61022 1.00018Z",
    fill: "#8F9EA9",
    stroke: "#8F9EA9",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSettingsPrev);
export default __webpack_public_path__ + "static/media/adminSettingsPrev.760a820ded6224fa22265efdd8034225.svg";
export { ForwardRef as ReactComponent };